/** select columns of table "base_themes" */
export var Base_Themes_Select_Column;
(function (Base_Themes_Select_Column) {
    /** column name */
    Base_Themes_Select_Column["Id"] = "id";
    /** column name */
    Base_Themes_Select_Column["ThemeColor_1"] = "theme_color_1";
    /** column name */
    Base_Themes_Select_Column["ThemeColor_2"] = "theme_color_2";
    /** column name */
    Base_Themes_Select_Column["ThemeColor_3"] = "theme_color_3";
    /** column name */
    Base_Themes_Select_Column["ThemeColor_4"] = "theme_color_4";
})(Base_Themes_Select_Column || (Base_Themes_Select_Column = {}));
/** select columns of table "bases" */
export var Bases_Select_Column;
(function (Bases_Select_Column) {
    /** column name */
    Bases_Select_Column["Block"] = "block";
    /** column name */
    Bases_Select_Column["Id"] = "id";
    /** column name */
    Bases_Select_Column["Issuer"] = "issuer";
    /** column name */
    Bases_Select_Column["Metadata"] = "metadata";
    /** column name */
    Bases_Select_Column["Symbol"] = "symbol";
    /** column name */
    Bases_Select_Column["Type"] = "type";
})(Bases_Select_Column || (Bases_Select_Column = {}));
/** select columns of table "changes_collection" */
export var Changes_Collection_Select_Column;
(function (Changes_Collection_Select_Column) {
    /** column name */
    Changes_Collection_Select_Column["Block"] = "block";
    /** column name */
    Changes_Collection_Select_Column["Caller"] = "caller";
    /** column name */
    Changes_Collection_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Changes_Collection_Select_Column["Field"] = "field";
    /** column name */
    Changes_Collection_Select_Column["Id"] = "id";
    /** column name */
    Changes_Collection_Select_Column["New"] = "new";
    /** column name */
    Changes_Collection_Select_Column["Old"] = "old";
    /** column name */
    Changes_Collection_Select_Column["OpType"] = "opType";
    /** column name */
    Changes_Collection_Select_Column["RefId"] = "ref_id";
})(Changes_Collection_Select_Column || (Changes_Collection_Select_Column = {}));
/** select columns of table "changes" */
export var Changes_Select_Column;
(function (Changes_Select_Column) {
    /** column name */
    Changes_Select_Column["Block"] = "block";
    /** column name */
    Changes_Select_Column["Caller"] = "caller";
    /** column name */
    Changes_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Changes_Select_Column["ExtraTransfers"] = "extraTransfers";
    /** column name */
    Changes_Select_Column["Field"] = "field";
    /** column name */
    Changes_Select_Column["Id"] = "id";
    /** column name */
    Changes_Select_Column["New"] = "new";
    /** column name */
    Changes_Select_Column["Old"] = "old";
    /** column name */
    Changes_Select_Column["OpType"] = "opType";
    /** column name */
    Changes_Select_Column["RefId"] = "ref_id";
})(Changes_Select_Column || (Changes_Select_Column = {}));
/** select columns of table "collection_banners" */
export var Collection_Banners_Select_Column;
(function (Collection_Banners_Select_Column) {
    /** column name */
    Collection_Banners_Select_Column["CollectionId"] = "collection_id";
    /** column name */
    Collection_Banners_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Collection_Banners_Select_Column["Image"] = "image";
})(Collection_Banners_Select_Column || (Collection_Banners_Select_Column = {}));
/** select columns of table "collections" */
export var Collections_Select_Column;
(function (Collections_Select_Column) {
    /** column name */
    Collections_Select_Column["Block"] = "block";
    /** column name */
    Collections_Select_Column["Id"] = "id";
    /** column name */
    Collections_Select_Column["Issuer"] = "issuer";
    /** column name */
    Collections_Select_Column["Max"] = "max";
    /** column name */
    Collections_Select_Column["Metadata"] = "metadata";
    /** column name */
    Collections_Select_Column["MetadataContentType"] = "metadata_content_type";
    /** column name */
    Collections_Select_Column["MetadataDescription"] = "metadata_description";
    /** column name */
    Collections_Select_Column["MetadataImage"] = "metadata_image";
    /** column name */
    Collections_Select_Column["MetadataName"] = "metadata_name";
    /** column name */
    Collections_Select_Column["Symbol"] = "symbol";
})(Collections_Select_Column || (Collections_Select_Column = {}));
/** select columns of table "distinct_kanaria_nfts" */
export var Distinct_Kanaria_Nfts_Select_Column;
(function (Distinct_Kanaria_Nfts_Select_Column) {
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Block"] = "block";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Burned"] = "burned";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["CollectionId"] = "collectionId";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["EquippedId"] = "equipped_id";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Forsale"] = "forsale";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Id"] = "id";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Metadata"] = "metadata";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["MetadataDescription"] = "metadata_description";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["MetadataImage"] = "metadata_image";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["MetadataName"] = "metadata_name";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["MetadataRarity"] = "metadata_rarity";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["MetadataRarityPercentage"] = "metadata_rarity_percentage";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Owner"] = "owner";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Pending"] = "pending";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Priority"] = "priority";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Properties"] = "properties";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Rootowner"] = "rootowner";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Sn"] = "sn";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Symbol"] = "symbol";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["Transferable"] = "transferable";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["TxBlock"] = "tx_block";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["TxCaller"] = "tx_caller";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["TxPending"] = "tx_pending";
    /** column name */
    Distinct_Kanaria_Nfts_Select_Column["UpdatedAt"] = "updated_at";
})(Distinct_Kanaria_Nfts_Select_Column || (Distinct_Kanaria_Nfts_Select_Column = {}));
/** select columns of table "distinct_nfts" */
export var Distinct_Nfts_Select_Column;
(function (Distinct_Nfts_Select_Column) {
    /** column name */
    Distinct_Nfts_Select_Column["Block"] = "block";
    /** column name */
    Distinct_Nfts_Select_Column["Burned"] = "burned";
    /** column name */
    Distinct_Nfts_Select_Column["CollectionId"] = "collectionId";
    /** column name */
    Distinct_Nfts_Select_Column["EquippedId"] = "equipped_id";
    /** column name */
    Distinct_Nfts_Select_Column["Forsale"] = "forsale";
    /** column name */
    Distinct_Nfts_Select_Column["Id"] = "id";
    /** column name */
    Distinct_Nfts_Select_Column["Metadata"] = "metadata";
    /** column name */
    Distinct_Nfts_Select_Column["MetadataContentType"] = "metadata_content_type";
    /** column name */
    Distinct_Nfts_Select_Column["MetadataImage"] = "metadata_image";
    /** column name */
    Distinct_Nfts_Select_Column["MetadataName"] = "metadata_name";
    /** column name */
    Distinct_Nfts_Select_Column["MetadataRarity"] = "metadata_rarity";
    /** column name */
    Distinct_Nfts_Select_Column["MetadataRarityPercentage"] = "metadata_rarity_percentage";
    /** column name */
    Distinct_Nfts_Select_Column["Owner"] = "owner";
    /** column name */
    Distinct_Nfts_Select_Column["Pending"] = "pending";
    /** column name */
    Distinct_Nfts_Select_Column["Priority"] = "priority";
    /** column name */
    Distinct_Nfts_Select_Column["Properties"] = "properties";
    /** column name */
    Distinct_Nfts_Select_Column["Rootowner"] = "rootowner";
    /** column name */
    Distinct_Nfts_Select_Column["Sn"] = "sn";
    /** column name */
    Distinct_Nfts_Select_Column["Symbol"] = "symbol";
    /** column name */
    Distinct_Nfts_Select_Column["Transferable"] = "transferable";
    /** column name */
    Distinct_Nfts_Select_Column["TxBlock"] = "tx_block";
    /** column name */
    Distinct_Nfts_Select_Column["TxCaller"] = "tx_caller";
    /** column name */
    Distinct_Nfts_Select_Column["TxPending"] = "tx_pending";
    /** column name */
    Distinct_Nfts_Select_Column["UpdatedAt"] = "updated_at";
})(Distinct_Nfts_Select_Column || (Distinct_Nfts_Select_Column = {}));
/** select columns of table "dutchie" */
export var Dutchie_Select_Column;
(function (Dutchie_Select_Column) {
    /** column name */
    Dutchie_Select_Column["Active"] = "active";
    /** column name */
    Dutchie_Select_Column["CurrentPrice"] = "current_price";
    /** column name */
    Dutchie_Select_Column["Id"] = "id";
    /** column name */
    Dutchie_Select_Column["InitialPrice"] = "initial_price";
    /** column name */
    Dutchie_Select_Column["Interval"] = "interval";
    /** column name */
    Dutchie_Select_Column["MinPrice"] = "min_price";
    /** column name */
    Dutchie_Select_Column["NftId"] = "nft_id";
    /** column name */
    Dutchie_Select_Column["Reduction"] = "reduction";
    /** column name */
    Dutchie_Select_Column["Sold"] = "sold";
    /** column name */
    Dutchie_Select_Column["StartTime"] = "start_time";
    /** column name */
    Dutchie_Select_Column["Tick"] = "tick";
})(Dutchie_Select_Column || (Dutchie_Select_Column = {}));
/** select columns of table "gems_enabled" */
export var Gems_Enabled_Select_Column;
(function (Gems_Enabled_Select_Column) {
    /** column name */
    Gems_Enabled_Select_Column["Enabled"] = "enabled";
    /** column name */
    Gems_Enabled_Select_Column["Id"] = "id";
})(Gems_Enabled_Select_Column || (Gems_Enabled_Select_Column = {}));
/** select columns of table "hatched_birds" */
export var Hatched_Birds_Select_Column;
(function (Hatched_Birds_Select_Column) {
    /** column name */
    Hatched_Birds_Select_Column["Id"] = "id";
})(Hatched_Birds_Select_Column || (Hatched_Birds_Select_Column = {}));
/** select columns of table "nfts" */
export var Nfts_Select_Column;
(function (Nfts_Select_Column) {
    /** column name */
    Nfts_Select_Column["Block"] = "block";
    /** column name */
    Nfts_Select_Column["Burned"] = "burned";
    /** column name */
    Nfts_Select_Column["CollectionId"] = "collectionId";
    /** column name */
    Nfts_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Nfts_Select_Column["EquippedId"] = "equipped_id";
    /** column name */
    Nfts_Select_Column["Forsale"] = "forsale";
    /** column name */
    Nfts_Select_Column["Id"] = "id";
    /** column name */
    Nfts_Select_Column["IdMd5"] = "id_md5";
    /** column name */
    Nfts_Select_Column["Metadata"] = "metadata";
    /** column name */
    Nfts_Select_Column["MetadataContentType"] = "metadata_content_type";
    /** column name */
    Nfts_Select_Column["MetadataDescription"] = "metadata_description";
    /** column name */
    Nfts_Select_Column["MetadataImage"] = "metadata_image";
    /** column name */
    Nfts_Select_Column["MetadataName"] = "metadata_name";
    /** column name */
    Nfts_Select_Column["MetadataProperties"] = "metadata_properties";
    /** column name */
    Nfts_Select_Column["MetadataRarity"] = "metadata_rarity";
    /** column name */
    Nfts_Select_Column["MetadataRarityPercentage"] = "metadata_rarity_percentage";
    /** column name */
    Nfts_Select_Column["Owner"] = "owner";
    /** column name */
    Nfts_Select_Column["Pending"] = "pending";
    /** column name */
    Nfts_Select_Column["Priority"] = "priority";
    /** column name */
    Nfts_Select_Column["Properties"] = "properties";
    /** column name */
    Nfts_Select_Column["Rootowner"] = "rootowner";
    /** column name */
    Nfts_Select_Column["Sn"] = "sn";
    /** column name */
    Nfts_Select_Column["Symbol"] = "symbol";
    /** column name */
    Nfts_Select_Column["Transferable"] = "transferable";
    /** column name */
    Nfts_Select_Column["TxBlock"] = "txBlock";
    /** column name */
    Nfts_Select_Column["TxCaller"] = "txCaller";
    /** column name */
    Nfts_Select_Column["TxPending"] = "txPending";
    /** column name */
    Nfts_Select_Column["UpdatedAt"] = "updated_at";
})(Nfts_Select_Column || (Nfts_Select_Column = {}));
/** select columns of table "nfts_stats" */
export var Nfts_Stats_Select_Column;
(function (Nfts_Stats_Select_Column) {
    /** column name */
    Nfts_Stats_Select_Column["CollectionId"] = "collection_id";
    /** column name */
    Nfts_Stats_Select_Column["Count"] = "count";
})(Nfts_Stats_Select_Column || (Nfts_Stats_Select_Column = {}));
/** column ordering options */
export var Order_By;
(function (Order_By) {
    /** in ascending order, nulls last */
    Order_By["Asc"] = "asc";
    /** in ascending order, nulls first */
    Order_By["AscNullsFirst"] = "asc_nulls_first";
    /** in ascending order, nulls last */
    Order_By["AscNullsLast"] = "asc_nulls_last";
    /** in descending order, nulls first */
    Order_By["Desc"] = "desc";
    /** in descending order, nulls first */
    Order_By["DescNullsFirst"] = "desc_nulls_first";
    /** in descending order, nulls last */
    Order_By["DescNullsLast"] = "desc_nulls_last";
})(Order_By || (Order_By = {}));
/** select columns of table "parts" */
export var Parts_Select_Column;
(function (Parts_Select_Column) {
    /** column name */
    Parts_Select_Column["BaseId"] = "base_id";
    /** column name */
    Parts_Select_Column["Equippable"] = "equippable";
    /** column name */
    Parts_Select_Column["Id"] = "id";
    /** column name */
    Parts_Select_Column["Metadata"] = "metadata";
    /** column name */
    Parts_Select_Column["PartId"] = "part_id";
    /** column name */
    Parts_Select_Column["Src"] = "src";
    /** column name */
    Parts_Select_Column["Type"] = "type";
    /** column name */
    Parts_Select_Column["Z"] = "z";
})(Parts_Select_Column || (Parts_Select_Column = {}));
/** select columns of table "recently_listed" */
export var Recently_Listed_Select_Column;
(function (Recently_Listed_Select_Column) {
    /** column name */
    Recently_Listed_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Recently_Listed_Select_Column["Forsale"] = "forsale";
    /** column name */
    Recently_Listed_Select_Column["Id"] = "id";
})(Recently_Listed_Select_Column || (Recently_Listed_Select_Column = {}));
/** select columns of table "resources_base_themes" */
export var Resources_Base_Themes_Select_Column;
(function (Resources_Base_Themes_Select_Column) {
    /** column name */
    Resources_Base_Themes_Select_Column["ResourceId"] = "resource_id";
    /** column name */
    Resources_Base_Themes_Select_Column["ThemeId"] = "theme_id";
})(Resources_Base_Themes_Select_Column || (Resources_Base_Themes_Select_Column = {}));
/** select columns of table "resources_parts" */
export var Resources_Parts_Select_Column;
(function (Resources_Parts_Select_Column) {
    /** column name */
    Resources_Parts_Select_Column["PartId"] = "part_id";
    /** column name */
    Resources_Parts_Select_Column["ResourceId"] = "resource_id";
})(Resources_Parts_Select_Column || (Resources_Parts_Select_Column = {}));
/** select columns of table "resources" */
export var Resources_Select_Column;
(function (Resources_Select_Column) {
    /** column name */
    Resources_Select_Column["BaseId"] = "base_id";
    /** column name */
    Resources_Select_Column["Id"] = "id";
    /** column name */
    Resources_Select_Column["Metadata"] = "metadata";
    /** column name */
    Resources_Select_Column["MetadataContentType"] = "metadata_content_type";
    /** column name */
    Resources_Select_Column["NftId"] = "nft_id";
    /** column name */
    Resources_Select_Column["Parts"] = "parts";
    /** column name */
    Resources_Select_Column["Pending"] = "pending";
    /** column name */
    Resources_Select_Column["Replace"] = "replace";
    /** column name */
    Resources_Select_Column["SlotId"] = "slot_id";
    /** column name */
    Resources_Select_Column["Src"] = "src";
    /** column name */
    Resources_Select_Column["Theme"] = "theme";
    /** column name */
    Resources_Select_Column["Thumb"] = "thumb";
})(Resources_Select_Column || (Resources_Select_Column = {}));
/** select columns of table "sales" */
export var Sales_Select_Column;
(function (Sales_Select_Column) {
    /** column name */
    Sales_Select_Column["Day"] = "day";
    /** column name */
    Sales_Select_Column["Month"] = "month";
    /** column name */
    Sales_Select_Column["Month3"] = "month3";
    /** column name */
    Sales_Select_Column["Week"] = "week";
})(Sales_Select_Column || (Sales_Select_Column = {}));
/** select columns of table "singular_blacklisted_accounts" */
export var Singular_Blacklisted_Accounts_Select_Column;
(function (Singular_Blacklisted_Accounts_Select_Column) {
    /** column name */
    Singular_Blacklisted_Accounts_Select_Column["Account"] = "account";
    /** column name */
    Singular_Blacklisted_Accounts_Select_Column["CreatedAt"] = "created_at";
})(Singular_Blacklisted_Accounts_Select_Column || (Singular_Blacklisted_Accounts_Select_Column = {}));
/** select columns of table "singular_blacklisted_collections" */
export var Singular_Blacklisted_Collections_Select_Column;
(function (Singular_Blacklisted_Collections_Select_Column) {
    /** column name */
    Singular_Blacklisted_Collections_Select_Column["CollectionId"] = "collection_id";
    /** column name */
    Singular_Blacklisted_Collections_Select_Column["CreatedAt"] = "created_at";
})(Singular_Blacklisted_Collections_Select_Column || (Singular_Blacklisted_Collections_Select_Column = {}));
/** select columns of table "singular_curated_collections" */
export var Singular_Curated_Collections_Select_Column;
(function (Singular_Curated_Collections_Select_Column) {
    /** column name */
    Singular_Curated_Collections_Select_Column["CollectionId"] = "collection_id";
    /** column name */
    Singular_Curated_Collections_Select_Column["CreatedAt"] = "created_at";
})(Singular_Curated_Collections_Select_Column || (Singular_Curated_Collections_Select_Column = {}));
/** select columns of table "singular_curated" */
export var Singular_Curated_Select_Column;
(function (Singular_Curated_Select_Column) {
    /** column name */
    Singular_Curated_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Singular_Curated_Select_Column["NftId"] = "nft_id";
})(Singular_Curated_Select_Column || (Singular_Curated_Select_Column = {}));
/** select columns of table "singular_hidden_collections" */
export var Singular_Hidden_Collections_Select_Column;
(function (Singular_Hidden_Collections_Select_Column) {
    /** column name */
    Singular_Hidden_Collections_Select_Column["CollectionId"] = "collection_id";
    /** column name */
    Singular_Hidden_Collections_Select_Column["CreatedAt"] = "created_at";
})(Singular_Hidden_Collections_Select_Column || (Singular_Hidden_Collections_Select_Column = {}));
/** select columns of table "singular_nsfw_collections" */
export var Singular_Nsfw_Collections_Select_Column;
(function (Singular_Nsfw_Collections_Select_Column) {
    /** column name */
    Singular_Nsfw_Collections_Select_Column["CollectionId"] = "collection_id";
    /** column name */
    Singular_Nsfw_Collections_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Singular_Nsfw_Collections_Select_Column["Reason"] = "reason";
})(Singular_Nsfw_Collections_Select_Column || (Singular_Nsfw_Collections_Select_Column = {}));
/** select columns of table "singular_nsfw_nfts" */
export var Singular_Nsfw_Nfts_Select_Column;
(function (Singular_Nsfw_Nfts_Select_Column) {
    /** column name */
    Singular_Nsfw_Nfts_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Singular_Nsfw_Nfts_Select_Column["NftId"] = "nft_id";
    /** column name */
    Singular_Nsfw_Nfts_Select_Column["Reason"] = "reason";
})(Singular_Nsfw_Nfts_Select_Column || (Singular_Nsfw_Nfts_Select_Column = {}));
/** select columns of table "singular_verified_collections" */
export var Singular_Verified_Collections_Select_Column;
(function (Singular_Verified_Collections_Select_Column) {
    /** column name */
    Singular_Verified_Collections_Select_Column["CollectionId"] = "collection_id";
    /** column name */
    Singular_Verified_Collections_Select_Column["CreatedAt"] = "created_at";
})(Singular_Verified_Collections_Select_Column || (Singular_Verified_Collections_Select_Column = {}));
/** select columns of table "system" */
export var System_Select_Column;
(function (System_Select_Column) {
    /** column name */
    System_Select_Column["PurchaseEnabled"] = "purchaseEnabled";
})(System_Select_Column || (System_Select_Column = {}));
/** select columns of table "yuletide_item_track" */
export var Yuletide_Item_Track_Select_Column;
(function (Yuletide_Item_Track_Select_Column) {
    /** column name */
    Yuletide_Item_Track_Select_Column["Id"] = "id";
    /** column name */
    Yuletide_Item_Track_Select_Column["ItemCount"] = "item_count";
})(Yuletide_Item_Track_Select_Column || (Yuletide_Item_Track_Select_Column = {}));
export const NftsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'nfts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nfts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'owner' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_in' },
                                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'burned' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: '_eq' },
                                                        value: { kind: 'StringValue', value: '', block: false },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'symbol' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata_name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata_description' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata_image' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'children' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'metadata_name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'metadata_image' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sn' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resources' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'metadata_content_type' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'thumb' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'sn' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'metadata_properties' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'collection' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'metadata_name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=graphql.js.map